import React from "react";
import UaeMofaHead from "../../UaeAttestation/UaeMofa/UaeMofaHead";
import "./../../UaeAttestation/UaeMofa/UaeMofa.css";
import BahrainMofaMain from "./BahrainMofaMain";

const BahrainMofa = () => {
  return (
    <div className="uaeMofaContainer">
      <UaeMofaHead />
      <BahrainMofaMain />
    </div>
  );
};

export default BahrainMofa;
